var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configDetails"},_vm._l((_vm.resumeData.configSelected),function(item,i){return _c('ResumeCard',{key:i,attrs:{"cardKey":i,"cardTitle":item.label,"colorImg":item.colorImg,"colorDesignation":item.designation,"price":parseFloat(item.price).toFixed(2),"route":item.route}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }